import { Outlet } from 'react-router-dom';
import { Provider } from 'mobx-react';
import s from './index.module.scss';
import 'amfe-flexible'; //设置字体大小为屏幕的十分之一
import grtStore from '@/store/grtStore';
import withRouter from '@/components/withRouter';
import { useEffect } from 'react';
import { Storage } from '@/utils/Storage';
import VConsole from 'vconsole';
import { openConsole } from '@/utils/Mobile';
const MobileLayout = (props) => {
    let console = props.searchParams.get('console');
    useEffect(() => {
        if (console) {
            Storage.set('console', console);
        }
    }, [console]);
    useEffect(() => {
        let console = Storage.get('console');
        if (console) {
            window.vConsole = new VConsole();
        }
    }, []);
    return (
        <Provider store={grtStore}>
            <div onClick={openConsole} className={[`grt-box grt-mobile-box ${s['mobile-wrap']}`]}>
                <Outlet></Outlet>
            </div>
        </Provider>
    );
};

export default withRouter(MobileLayout);
